import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import logosort from "assets/images/ugifts/dummyBanner/sort.png"
import sortAsc from "assets/images/ugifts/icons/sort/sort_asc.png"
import sortDesc from "assets/images/ugifts/icons/sort/sort_desc.png"

import { Button } from "@material-ui/core"

import UgiftEmptyState from "./UgiftEmptyState"
import emptyLogin from "assets/images/ugifts/icons/empty/empty_login.png"

const sortData = [
  {
    icon: sortAsc,
    name: "A to Z",
    option: "ASC",
  },
  {
    icon: sortDesc,
    name: "Z to A",
    option: "DESC",
  },
]

const Categories = props => {
  const history = useHistory()

  const [language, setLanguage] = useState("eng")

  const [modal_sort, setmodal_sort] = useState(false)

  function tog_sort() {
    setmodal_sort(!modal_sort)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [tableData, setTableData] = useState(null)
  const [listType, setListType] = useState("list_category")
  const [sortType, setSortType] = useState("ASC")
  const [searchData, setSearchData] = useState("")
  const [basketCount, setBasketCount] = useState(null)
  const [country, setCountry] = useState("")
  const [isGuest, setIsGuest] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    } else {
      setIsGuest(true)
    }

    if (localStorage.getItem("basketCount")) {
      setBasketCount(localStorage.getItem("basketCount"))
    }

    if (localStorage.getItem("country")) {
      setCountry(localStorage.getItem("country"))
    }

    if (localStorage.getItem("I18N_LANGUAGE")) {
      setLanguage(localStorage.getItem("I18N_LANGUAGE"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token && country) {
      getList()
      if (!isGuest) getBasketData()
      console.log("use effect")
    }
  }, [token, listType, sortType])

  const getList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", listType)
    urlencoded.append("order_by", sortType)
    urlencoded.append("filter_by_country_id", country)
    // urlencoded.append("option", "get_api_token")
    // urlencoded.append("source", "web")
    // urlencoded.append("api_key", "UgiftZi)$rnK}K%I8PZKey")

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_GET_CATEGORY,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setTableData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  function resetSorting() {
    setSortType("ASC")
  }

  function onSubmitSearchField(e) {
    e.preventDefault()
    history.push("/product-search?q=" + searchData)
  }

  function onChangeSearchField(e) {
    setSearchData(e.target.value)
  }

  const getBasketData = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_basket")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      var calculate = 0
      postresponse.table.products.forEach(product => {
        calculate += parseInt(product.quantity)
      })
      localStorage.setItem("basketCount", calculate)
      setBasketCount(calculate)
    } else {
    }
  }

  const multiLanguageHandler = data => {
    switch (language) {
      case "eng":
        return data.en
      case "cn":
        return data.cn ? data.cn : data.en
      case "jp":
        return data.jp ? data.jp : data.en
      default:
        return data.en
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "100px",
                  paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                      </Col>
                      <Col
                        className="px-3"
                        style={{ paddingTop: "14px", paddingBottom: "14px" }}
                      >
                        <form
                          className="app-search"
                          style={{ padding: 0 }}
                          onSubmit={onSubmitSearchField}
                        >
                          <div className="position-relative">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={props.t("Search all products")}
                              // value={companyvaluesearch}
                              onChange={onChangeSearchField}
                              style={{ borderRadius: "8px", maxHeight: "28px" }}
                            />
                            <span
                              className="bx bx-search-alt"
                              style={{ lineHeight: "28px" }}
                            />
                          </div>
                        </form>
                      </Col>
                      <Col xs={2} className="pe-0 ">
                        <Link to="/basket">
                          <Button className="h-100 m-0">
                            <i
                              className="bx bx-basket align-middle text-white"
                              style={{ fontSize: "28px" }}
                            />
                            {!isGuest && basketCount != 0 && (
                              <span
                                className="badge bg-danger rounded-pill"
                                style={{
                                  position: "absolute",
                                  top: 12,
                                  right: 8,
                                }}
                              >
                                {basketCount}
                              </span>
                            )}
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "42px",
                        position: "fixed",
                        top: 56,
                        zIndex: 1020,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={6} className="p-0">
                        <Button
                          className="w-100 h-100 m-0"
                          style={
                            listType == "list_category"
                              ? {
                                  borderRadius: 0,
                                  borderBottom: "5px",
                                  borderBottomColor: "#45A461",
                                  borderBottomStyle: "solid",
                                  backgroundColor: "white",
                                  textTransform: "none",
                                }
                              : {
                                  borderRadius: 0,
                                  borderBottom: "5px",
                                  borderBottomColor: "#E3E3E3",
                                  borderBottomStyle: "solid",
                                  backgroundColor: "white",
                                  textTransform: "none",
                                }
                          }
                          onClick={() => {
                            setListType("list_category")
                          }}
                        >
                          <span
                            className="font-size-15"
                            style={
                              listType == "list_category"
                                ? { color: "#45A461" }
                                : { color: "#E3E3E3" }
                            }
                          >
                            {props.t("Categories")}
                          </span>
                        </Button>
                      </Col>
                      <Col xs={6} className="p-0">
                        <Button
                          className="w-100 h-100 m-0"
                          style={
                            listType == "list_brand"
                              ? {
                                  borderRadius: 0,
                                  borderBottom: "5px",
                                  borderBottomColor: "#45A461",
                                  borderBottomStyle: "solid",
                                  backgroundColor: "white",
                                  textTransform: "none",
                                }
                              : {
                                  borderRadius: 0,
                                  borderBottom: "5px",
                                  borderBottomColor: "#E3E3E3",
                                  borderBottomStyle: "solid",
                                  backgroundColor: "white",
                                  textTransform: "none",
                                }
                          }
                          onClick={() => {
                            setListType("list_brand")
                          }}
                        >
                          <span
                            className="font-size-15"
                            style={
                              listType == "list_brand"
                                ? { color: "#45A461" }
                                : { color: "#E3E3E3" }
                            }
                          >
                            {props.t("Brands")}
                          </span>
                        </Button>
                      </Col>
                    </Row>
                    <Row className="px-3">
                      <Col xs="auto px-0">
                        <button className="btn btn-link">
                          <img
                            src={logosort}
                            alt=""
                            style={{
                              // position: "absolute",
                              // objectFit: "contain",
                              maxHeight: "24px",
                            }}
                            onClick={tog_sort}
                          />
                        </button>
                      </Col>
                      <Col className="font-size-14 text-end align-self-center px-0">
                        <button
                          className="btn btn-link"
                          onClick={() => {
                            resetSorting()
                          }}
                        >
                          {props.t("Reset")}
                        </button>
                      </Col>
                    </Row>
                    {tableData &&
                      tableData.map((productData, index) => (
                        <Row
                          className="g-0"
                          style={{ backgroundColor: "white" }}
                        >
                          <Col className="px-3 mb-0">
                            {/* <Link
                              to={
                                "/products?id=" +
                                productData.id +
                                "&type=" +
                                listType
                              }
                            > */}
                            <Card
                              className="py-4 mb-0 shadow-none"
                              key={`productData-${index}`}
                              style={{
                                borderRadius: "0",
                                borderBottom: "1px",
                                borderBottomColor: "#D6D6D6",
                                borderBottomStyle: "solid",
                              }}
                              onClick={() => {
                                history.push(
                                  "/products?id=" +
                                    productData.id +
                                    "&type=" +
                                    listType
                                )
                              }}
                            >
                              <Row>
                                <Col xs="auto">
                                  <img
                                    src={productData.image}
                                    className="avatar-xs"
                                    alt=""
                                    style={{
                                      maxWidth: "24px",
                                      maxHeight: "24px",
                                    }}
                                  />
                                </Col>
                                <Col>
                                  <Row>
                                    <Col>
                                      <span
                                        className="font-size-15 "
                                        style={{
                                          color: productData.colour_code
                                            ? productData.colour_code
                                            : "#4A4A4A",
                                        }}
                                      >
                                        {
                                          multiLanguageHandler(
                                            productData.multiple_languages
                                          ).name
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xs="auto">
                                  <Row>
                                    <Col>
                                      <i
                                        className="bx bx-cookie align-middle font-size-20"
                                        style={{ color: "#A5A5A5" }}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Card>
                            {/* </Link> */}
                          </Col>
                        </Row>
                      ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modal_sort}
        toggle={() => {
          tog_sort()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {props.t("Sort by")}
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_sort(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {sortData.map((data, index) => (
            <Card
              className="py-4 mb-0 shadow-none"
              style={{
                borderRadius: "0",
                borderBottom: "1px",
                borderBottomColor: "#D6D6D6",
                borderBottomStyle: "solid",
              }}
            >
              <Row>
                <Col xs="auto">
                  <img
                    // src={"https://dummyimage.com/21x21/000/fff"}
                    src={data.icon}
                    // className="avatar-lg"
                    alt=""
                  />
                </Col>
                <Col>
                  <Row>
                    <Col>
                      <span
                        className="font-size-15 "
                        style={
                          sortType == data.option
                            ? { color: "#4A4A4A", fontWeight: 700 }
                            : { color: "#4A4A4A" }
                        }
                      >
                        {data.name}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col xs="auto">
                  <Row>
                    <Col>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios1"
                        value={data.option}
                        checked={sortType == data.option}
                        onChange={() => {
                          setSortType(data.option)
                          tog_sort()
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          ))}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_sort()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(Categories)

Categories.propTypes = {
  t: PropTypes.any,
}
